import styled from 'styled-components';

export const ArticleIngress = styled.div`
  text-align: center;
`;
